<template>
  <div class="flex flex-row justify-start items-center py-3 space-x-3 border-t">
    <input
      v-model="localSelectedItemsIds"
      :id="localOrderItem._id"
      :value="localOrderItem._id"
      type="checkbox"
      class="w-5 h-5 sm:w-4 sm:h-4 text-orange-organization focus:ring-0 active:ring-0 rounded-sm border-gray-500 disabled:border-gray-200 disabled:bg-gray-100"
      v-if="showCheckbox"
      @change="checkSelected($event)"
    >

    <div
      class="w-12 h-12"
    >
      <img
        v-if="localOrderItem.image"
        :src="localOrderItem.image"
        class="w-12 h-12 rounded-full"
      >
      <img
        v-else
        src="@/assets/load.gif"
        class="w-12 h-12 rounded-full"
      >
    </div>

    <span class="text-base font-medium">{{ localOrderItem.name }}</span>
  </div>
</template>

<script>
import { addImagesInOrderItems as addImages } from '@/utils/csExternal/images'

export default {
  name: 'ExternalOrderItemInfo',

  props: {
    orderItem: Object,
    selectedItemsIds: Array,
    showCheckbox: Boolean,
    organization: String
  },

  data () {
    return {
      localOrderItem: {}
    }
  },

  created () {
    this.localOrderItem = this.orderItem
    this.setImage()
  },

  computed: {
    localSelectedItemsIds: {
      get () {
        return this.selectedItemsIds
      },
      set () {}
    }
  },

  methods: {
    async setImage () {
      const itemWithImage = await addImages([this.localOrderItem], {}, this.organization)
      this.localOrderItem.image = itemWithImage[0].image
      this.$forceUpdate()
    },

    checkSelected ($event) {
      if ($event.target.checked) {
        this.selectedItemsIds.push(this.localOrderItem._id)

        return
      }

      const index = this.selectedItemsIds.indexOf(this.localOrderItem._id)

      this.selectedItemsIds.splice(index, 1)
    }
  }
}
</script>
